export const vehicleValuesKey = new Map([
  ['vehicleType', "Vehicle Type"],
  ['vehicleLevel', "Vehicle Level"],
  ['make', "Make"],
  ['model', "Model"],
  ['year', "Year"],
  ['noOfDoors', "No. of Doors"],
  ['capacity', "Capacity"],
  ['bvSpec', "BV Spec #"],
  ['upfit', "Upfit Option"],
  ['eqClassCode', "Eq Class Code"],
  ['driveTrain', "Drive Train"],
  ['fuelType', "Fuel Type"],
  ['catalogDescription', "LEADR Description"],
  ['snowSetup', "Snow Setup"],
  ['detailedDescription', "Detailed Description"],
  ['eOneDescription', "EOne Description"],
  ['poDescription1', "PO Description 1"],
  ['poDescription2', "PO Description 2"],
  ['actualPrice', "Actual Price"],
  ['budgetingPercent', "Budgeting Percent"],
  ['budgetingPrice', "Budgeting Price"],
  ['leaseTerm', "Useful Life / Lease Terms"],
  ['monthlyDeprecation', "Monthly Depreciation"],
  ['logoed', "Logoed"],
  ['status', "Status"],
  ['category', "Category"],
  ['price', "Price"],
  ['stateAvailability', "State Availability"],
  ['programStatus', "Program Status"],
  ['annualHours', "Annual Hours"],
  ['deckSize', "Deck Size"],
  ['deckType', "Deck Type"],
  ['autonomous', "Autonomous"],
  ['size', "Size"],
  ['lengthAttr', 'Length'],
  ['seatingCapacity', 'Seating Capacity'],
  ['enclosedCab', 'Enclosed Cab'],
  ['classType', 'Class Type'],
  ['groupType', 'Group Type'],
  ['vehicleClass', 'Vehicle Class'],
  ['vehicleGrossWeightRating', 'Gross Vehicle Weight Rating'],
  ['cdl', 'CDL Required'],
  ['trim', 'Trim'],
  ['use', 'Use (Tags)'],
  ['truckSize', 'Truck Size'],
  ['category2', 'Category 2'],
  ['manufacturer', 'Manufacturer'],
  ['categoryType', 'Category Type'],
  ['type', 'Type']
]);

export const kitValuesKey = new Map([
  ['kitDescription1', "Kit Description 1"],
  ['kitDescription2', "Kit Description 2"],
  ['unitPrice', "Kit Unit Price"],
  ['quantity', "Quantity"],
]);

export const assetModelAttributes = [
  'noOfDoors',
  'capacity',
  'upfit',
  'snowSetup',
  'driveTrain',
  'fuelType',
  'stateAvailability',
  'programStatus',
  'annualHours',
  'deckSize',
  'deckType',
  'autonomous',
  'category',
  'category2',
  'categoryType',
  'size',
  'lengthAttr',
  'seatingCapacity',
  'enclosedCab',
  'use',
  'cdl',
  'trim',
  'vehicleGrossWeightRating',
  'vehicleClass',
  'groupType',
  'classType',
  'truckSize',
  'type',
  'make',
  'manufacturer',
]

export const vehicleRequiredFields = [
  "vehicleLevel",
  "make",
  "model",
  "year",
  "noOfDoors",
  "truckSize",
  "bvSpec",
  "eqClassCode",
  "driveTrain",
  "fuelType",
  "catalogDescription",
  "eOneDescription",
  "detailedDescription",
  "poDescription1",
  "poDescription2",
  "actualPrice",
  "budgetingPercent",
  "budgetingPrice",
  "leaseTerm",
  "monthlyDeprecation",
  "status",
  "classType",
  "groupType",
  "vehicleClass",
  "vehicleGrossWeightRating",
  "cdl",
  "trim",
  "use"
]

export const mowerRequiredFields = [
  "manufacturer",
  "model",
  "year",
  "catalogDescription",
  "eOneDescription",
  "detailedDescription",
  "poDescription1",
  "poDescription2",
  "actualPrice",
  "budgetingPercent",
  "budgetingPrice",
  "leaseTerm",
  "monthlyDeprecation",
  "status",
  "category",
  "price",
  "stateAvailability",
  "programStatus",
  "annualHours",
  "deckSize",
  "deckType",
  "autonomous",
  'eqClassCode'
]

export const snowRequiredFields = [
  "category",
  "categoryType",
  "manufacturer",
  "model",
  "year",
  "size",
  "eqClassCode",
  "catalogDescription",
  "eOneDescription",
  "detailedDescription",
  "poDescription1",
  "poDescription2",
  "actualPrice",
  "budgetingPercent",
  "budgetingPrice",
  "leaseTerm",
  "monthlyDeprecation",
  "status",
  "type",
  "price"
]

export const trailerRequiredField = [
  "category",
  "manufacturer",
  "model",
  "length",
  "eqClassCode",
  "fuelType",
  "price",
  "catalogDescription",
  "eOneDescription",
  "detailedDescription",
  "poDescription1",
  "poDescription2",
  "actualPrice",
  "budgetingPercent",
  "budgetingPrice",
  "leaseTerm",
  "monthlyDeprecation",
  "status",
]

export const utilityVehicleRequiredField = [
  "manufacturer",
  "model",
  "year",
  "seatingCapacity",
  "capacity",
  "enclosedCab",
  "eqClassCode",
  "price",
  "catalogDescription",
  "eOneDescription",
  "detailedDescription",
  "poDescription1",
  "poDescription2",
  "actualPrice",
  "budgetingPercent",
  "budgetingPrice",
  "leaseTerm",
  "monthlyDeprecation",
  "status",
  "stateAvailability",
  "programStatus",
  "annualHours",
  'driveTrain',
  'fuelType',
]

export const standardizedEquipmentRequiredFields = [
  "manufacturer",
  "model",
  "year",
  "catalogDescription",
  "eOneDescription",
  "detailedDescription",
  "poDescription1",
  "poDescription2",
  "actualPrice",
  "budgetingPercent",
  "budgetingPrice",
  "leaseTerm",
  "monthlyDeprecation",
  "status",
  "category",
  "price",
  "stateAvailability",
  "category2",
  "eqClassCode"
]

export const constructionEquipmentRequiredFields = [
  "category",
  "manufacturer",
  "model",
  "year",
  "price",
  "eqClassCode",
  "catalogDescription",
  "eOneDescription",
  "detailedDescription",
  "poDescription1",
  "poDescription2",
  "actualPrice",
  "budgetingPercent",
  "budgetingPrice",
  "leaseTerm",
  "monthlyDeprecation",
  "status",
  "category2"
]